<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	padding:60px 15%;
	display:flex;
	.left
		width:900px;
		margin-right:40px;
		.top
			display:flex;
			.top-l
				width:144px;
				height:200px;
			.top-r
				.top-title
					// height:42px;
					font-size:30px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:42px;
				.top-time
					// height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.4);
					// line-height:20px;
					margin-top:10px;
					padding:10px 0;
					border-bottom:1px solid #F1F1F1;
				.top-desc
					height:22px;
					font-size:16px;
					font-weight:500;
					color:rgba(7,19,54,0.8);
					line-height:22px;
					margin-top:26px;
					span
						margin-right:40px;
				.top-address
					height:22px;
					font-size:16px;
					font-weight:500;
					color:rgba(7,19,54,0.8);
					line-height:22px;
					margin-top:14px;
				.top-btn
					display:flex;
					margin-top:19px;
					color:rgba(255,255,255,1);
					font-size:12px;
					.top-btn-type
						// width:85px;
						padding:0 10px;
						height:24px;
						line-height:24px;
						background:rgba(209,173,10,1);
						border-radius:12px;
						text-align:center;
						margin-right:6px;
					.top-sign
						width:60px;
						height:24px;
						line-height:24px;
						background:rgba(33,177,104,1);
						border-radius:12px;
						text-align: center;
  					.top-over
						background:rgba(185,185,185,1) !important;
		.sel
			margin-top:78px;
			display:flex;
			cursor:pointer;
			padding:0 10px;
			border-bottom:1px solid rgba(241,241,241,1);
			.list
				padding:15px 20px 15px 0px;
				margin-right:20px;
				font-size:18px;
				font-weight:400;
				border-bottom:4px solid #fff;
			.list-sel
				color:rgba(7,19,54,1);
				border-bottom:4px solid rgba(39,81,203,1);
			.list-not
				color:rgba(7,19,54,0.6);
		.sel-body
			margin:42px 0px;
			.video-body
				position: relative;
				.videos
					width:810px;
					height:473px;
					margin:30px;
				.video-no
					position: absolute;
					width:810px;
					height:473px;
					margin:30px;
					background:#666;
					opacity:0.8;
					color:#fff;
					text-align:center;
					line-height:473px;
					font-size:26px;
			.down-title
				width:870px;
				height:58px;
				line-height:58px;
				background:rgba(249,249,249,1);
				font-size:16px;
				font-weight:400;
				color:rgba(7,19,54,0.6);
				letter-spacing:1px;
				padding-left:17px;
			.down-no
				text-align:center;
				margin-top:30px;
			.down-body
				display:flex;
				flex-wrap: wrap;
				.down-list
					width:420px;
					height:138px;
					display:flex;
					padding:16px 23px;
					margin-top:20px;
					.down-img
						width:80px;
						height:106px;
						margin-right:20px;
					.down-t
						height:22px;
						width:300px;
						font-size:16px;
						font-weight:400;
						color:rgba(7,19,54,1);
						line-height:22px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					.down-desc
						margin-top:10px;
						height:20px;
						font-size:14px;
						font-weight:400;
						color:rgba(151,157,172,1);
						line-height:20px;
						span
							margin-right:10px;
					.down-btn-list
						display:flex;
						margin-top:20px;
						.down-btn
							cursor:pointer;
							width:65px;
							text-align:center;
							height:30px;
							line-height:30px;
							border-radius:20px;
							border:1px solid rgba(39,81,203,1);
							font-size:14px;
							font-weight:400;
							color:rgba(39,81,203,1);
						.down-preview
							margin-left:10px;
							border:1px solid rgba(39,81,203,0.8);
	.right
		width:400px;
		.r-sign
			margin-left:30px;
			margin-top:30px;
			.r-s-title
				height:28px;
				font-size:20px;
				font-weight:500;
				color:rgba(7,19,54,1);
				line-height:28px;
			.r-s-form
				margin-top:7px;
				width:347px;
				height:303px;
				background:rgba(250,250,250,1);
				border-radius:12px;
				.r-form
					padding:0 28px;
					padding-top:25px;
					.r-input
						margin-bottom:5px;
					.r-btn
						width:291px;
						height:44px;
						background:rgba(39,81,203,1);
						border-radius:24px;
						border:1px solid rgba(39,81,203,1);
						font-size:16px;
						font-weight:500;
			.course-list
				margin-top:10px;
				display:flex;
				flex-wrap: wrap;
				// width:1374px;
				// height:450px;
				.courseing
					box-shadow:0px 2px 27px 0px rgba(0,84,116,0.11);
					width: 348px;
					height: 150px;
					border-radius: 10px;
					margin: 10px 5px;
					display:flex;
					position: relative;
					cursor:pointer;
				  	.list-img
						width: 348px;
						height: 150px;
						border-radius: 10px;
				  	.course-lists
						margin-right: 24px;
						position: absolute;
						left: 115px;
						top:30px;
						.l-title
							height:42px;
							font-size:15px;
							font-weight:500;
							color:rgba(7,19,54,1);
							line-height:21px;
							overflow: hidden;
							display: -webkit-box;
							text-overflow:ellipsis;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
						.l-name
							height:16px;
							font-size:12px;
							font-weight:400;
							color:rgba(7,19,54,0.6);
							line-height:16px;
							margin-top:7px;
						.l-time
							height:16px;
							font-size:12px;
							font-weight:400;
							color:rgba(7,19,54,0.6);
							line-height:16px;
							margin-top:2px;
						.l-btn
							display: flex;
							margin-top:6px;
							font-size:10px;
							font-weight:500;
							.l-type
								// width:85px;
								padding:0 10px;
								height:20px;
								line-height:20px;
								background:rgba(209,173,10,1);
								border-radius:10px;
								color: #ffffff;
								text-align: center;
								margin-right:6px;
		  					.l-type-fldjt
								background-color: #5C607D;
		  					.l-type-no
								background-color: #A3AB5F;
		  					.l-sign
								width:50px;
								height:20px;
								line-height:20px;
								background:rgba(33,177,104,1);
								border-radius:10px;
								color: #ffffff;
								text-align: center;
		  					.l-over
								background:rgba(185,185,185,1);
			.r-desc
				display:flex;
				align-items:center;
				justify-content:center;
				width:348px;
				height:114px;
				background:rgba(250,250,250,1);
				border-radius:12px;
				.r-d-img
					width:79px;
					height:79px;
					margin-left:9px;
				.r-d-info
					width:200px;
					height:78px;
					font-size:16px;
					font-weight:400;
					color:rgba(7,19,54,0.8);
					line-height:26px;
</style>
<style lang="stylus">
.r-input
    .el-input__inner
        width:291px;
        height:42px;
        background:rgba(255,255,255,1);
        border-radius:21px;
        border:1px solid rgba(235,235,235,1);
.r-form
	.el-form-item__error
      top: 8px !important;
</style>
<template>
  	<div class="main">
  		<div class="left">
  			<goBack></goBack>
	    	<div class="top">
	    		<div class="top-l"></div>
	    		<div class="top-r">
	    			<div class="top-title">{{list.title}}</div>
	    			<div class="top-time">发布  {{list.created_at}}</div>
	    			<div class="top-desc">
	    				<span>主讲人： {{list.speaker}}</span>
	    				<span>活动时间：  {{list.start_time}} - {{list.end_time}}</span>
	    				<!-- <span>系列：  {{list.series}}</span> -->
	    			</div>
	    			<div class="top-address">系列：  {{list.series}}</div>
	    			<div class="top-address">活动地址：  {{list.address}}</div>
	    			<div class="top-btn">
	    				<!-- <div class="top-btn-type">{{list.catagory}}</div> -->
	    				<div class="top-btn-type">{{list.tag_name}}</div>
	    				<div v-if="list.over" class="top-over top-sign">已结束</div>
	    				<div v-else class="top-sign">报名中</div>
	    			</div>
	    		</div>
	    	</div>
	    	<div class="sel">
		    	<div v-for="item in selList" class="list" :class="curtype == item.type ? 'list-sel' : 'list-not'" @click="selType(item.type)">{{item.name}}</div>
		    </div>
		    <div v-if="curtype == '1'" class="sel-body">
		    	<div class="text-content" v-html="list.introduct"></div>
		    </div>
		    <div v-if="curtype == '2'" class="sel-body">
		    	<div class="down-title">说明：课件知识产权归主讲律师所有。</div>
		    	<div v-if="!list.files.length " class="down-no">暂时没有课件</div>
		    	<div v-else class="down-body">
			    	<div v-for="item in list.files" class="down-list">
			    		<div>
			    			<img :src="'/static/img/format/' + item.postfix + '.jpg'" onerror="this.src='/static/img/format/noa.jpg'" class="down-img">
			    		</div>
			    		<div>
			    			<div class="down-t" :title="item.name">{{item.name}}</div>
			    			<div class="down-desc">
			    				<span>{{list.speaker}}</span>
			    				<span>{{item.created_at}}</span>
			    			</div>
			    			<div class="down-btn-list">
			    				<!-- <div class="down-btn" @click="down(item.path)"><a :href="item.path">下载</a></div> -->
			    				<div class="down-btn" @click="down(item.path)">下载</div>
			    				<div class="down-btn down-preview" @click="preview(item.hash_str)">预览</div>
			    			</div>
			    		</div>
			    	</div>
		    	</div>
		    </div>
		    <div v-if="curtype == '3'" class="sel-body">
		    	<div class="down-title">说明：课件知识产权归主讲律师所有。</div>
		    	<div v-if="list.review_video_url == '' " class="down-no">暂时没有课程回顾</div>
		    	<!-- <iframe style="width:810px;height:473px;margin:30px;" src="//player.bilibili.com/player.html?aid=30026198&cid=52330978&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe> -->
		    	<div v-else class="video-body">
		    		<iframe class="videos" :src="list.review_video_url" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
		    		<div v-if="!loginStatus" class="video-no">注册登录之后才能观看课程回顾哦！</div>
		    	</div>
		    </div>
	    </div>
	    <div class="right">
	    	<div class="r-sign">
	    		<div class="r-s-title">填写报名信息</div>
	    		<div class="r-s-form">
	    			<el-form :model="signform" :rules="signRules" ref="signform" class="r-form">
	    				<el-form-item prop="name">
		                    <el-input :disabled="list.over" class="r-input" v-model.trim="signform.name" size="medium" placeholder="您的姓名"></el-input>
		                    <!-- :placeholder="list.over ? '课程已结束':'您的姓名'" -->
		                </el-form-item>
		                <el-form-item prop="company">
		                    <el-input :disabled="list.over" class="r-input" v-model.trim="signform.company"  size="medium" placeholder="公司全称"></el-input>
		                </el-form-item>
		                <el-form-item prop="phone">
		                    <el-input :disabled="list.over" class="r-input" v-model.trim="signform.phone" size="medium" placeholder="您的电话"></el-input>
		                </el-form-item>
		                <el-form-item prop="job_title">
		                    <el-input :disabled="list.over" class="r-input" v-model.trim="signform.job_title"  size="medium" placeholder="您的职位"></el-input>
		                </el-form-item>
		                <el-form-item>
		                    <el-button :disabled="list.over" class="r-btn" @click="SignSubmitForm('signform')" :loading="signning" type="primary">确 定</el-button>
		                </el-form-item>
	    			</el-form>
	    		</div>
	    	</div>
	    	<div class="r-sign">
	    		<div class="r-s-title">推荐课程</div>
	    		<div class="course-list">
			    	<div v-if="!courseList.length" class="noList">暂时没有课程</div>
			    	<div v-else v-for="(item , index) in courseList" :key="index"  class="courseing" @click="$router.push({name: 'courseInfo', params: {course_id: item.id}})">
						<img :src="item.cover" class="list-img">
						<div class="course-lists">
							<div class="l-title">{{item.title}}</div>
							<div class="l-name">主讲人：{{item.speaker}}</div>
							<div class="l-time">活动时间：{{item.start_time}}-{{item.end_timehm}}</div>
							<div class="l-btn">
								<!-- <div class="l-type" v-if="item.catagory == '企业法务通'">{{item.catagory}}</div> -->
								<!-- <div class="l-type l-type-fldjt" v-else-if="item.catagory == '法律大讲堂'">{{item.catagory}}</div> -->
								<!-- <div class="l-type l-type-no" v-else>{{item.catagory}}</div> -->
								<div class="l-type">{{item.tag_name}}</div>
								<div v-if="item.issign" class="l-sign">报名中</div>
			        			<div v-else class="l-sign l-over">已结束</div>
							</div>
						</div>
			    	</div>
			    </div>
	    	</div>
	    	<div class="r-sign">
	    		<div class="r-desc">
	    			<div class="r-d-info">扫码弘商小程序二维码，随时关注课程信息，快速报名课程哦</div>
	    			<div v-viewer="{ 'navbar': false, 'toolbar': false, 'rotatable': false, 'scalable': false, 'keyboard': true}">
	    				<img src="/static/img/wechat1.png" title="点击放大" class="r-d-img">
	    			</div>
	    		</div>
	    	</div>
	    </div>
  	</div>
</template>

<script>
import moment from 'moment';
import goBack from '@/components/common/goBack';
export default {
  	name: 'CourseInfo',
  	data () {
  		var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机不能为空'))
            }
            if (/^1[3|4|5|6|7|8|9]\d{9}$/.test(value)) {  //验证手机号第二位可为6，
                callback()
            } else {
                return callback(new Error('手机号码错误'))
            }
        }
    	return {
    		imgUrl,
      		cid:'',
      		list:{},
      		selList:[
		      	{type:'1',name:'课程介绍'},
		      	{type:'2',name:'课件下载'},
		      	{type:'3',name:'课程回顾'}
		    ],
		    curtype:'1',
		    signform:{
		    	name:'',
		    	company:'',
		    	phone:'',
		    	job_title:''
		    },
		    signRules: {
                name: [
                  { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                company: [
                  { required: true, message: '公司全称不能为空', trigger: 'blur' }
                ],
                phone: [
                  { required: true, validator: checkPhone, trigger: 'blur' }
                ],
                job_title: [
                  { required: true, message: '职位不能为空', trigger: 'blur' }
                ]
            },
            signning: false,
            courseList:[],
            downList:[
            	{name:'胡小燕',title:'公司规章制度制定模板.pdf',time:'2020-02-11  14:30'},
            	{name:'胡小燕',title:'关于XX部门的XXX的辞退事宜.excl',time:'2020-02-11  14:30'},
            	{name:'胡小燕',title:'公司规章制度制定模板.pdf',time:'2020-02-11  14:30'}
            ],
    	}
  	},
  	components: {
        goBack
    },
  	computed:{
	    loginStatus() {
	      return this.$store.state.loginStatus;
	    },
	},
  	created() {
    	this.cid = Number(this.$route.params.course_id);
	},
	mounted(){
		this.getInfo();
		this.getCourse();
		// this.getApplyinfo();
		this.getSignInfo();
	},
	methods:{
		//课程内容tag
		selType(type){
	  		this.curtype = type;
	  	},
	  	//课程详情
		getInfo(){
			let url = 'wxm/course/info';
	  		let param = {
	  			id:this.cid
	  		};
	  		this.$http.get(url, {params:param} ).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				var datas = res.data.data;
	  				var timestamp = Date.parse(new Date());
	        		timestamp = timestamp / 1000;
	        		if (datas.end_time > timestamp) {
			          datas.over = false;
			        } else {
			          datas.over = true;
			        }
			        datas.created_at = moment(datas.created_at * 1000).format("YYYY-MM-DD HH:mm");
			        datas.start_time = moment(datas.start_time * 1000).format("YYYY-MM-DD HH:mm");
			        datas.end_time = moment(datas.end_time * 1000).format("HH:mm");
			        this.list = datas;
	  			}
	  		})
		},
		//是否报名，有返回报名信息
		getApplyinfo(){
			let url = 'wxm/course/applyinfo';
	  		let param = {
	  			notice_id:this.cid
	  		};
	  		this.$http.get(url, {params:param} ).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				console.log('1111111',res.data.data);
	  			}
	  		})
		},
		//获取上一次报名信息
		getSignInfo(){
			let url = 'wxm/course/getApplyinfo';
			this.$http.get(url).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				this.signform = res.data.data;
	  			}
	  		})
		},
		//获取推荐课程
		getCourse(){
	  		let url = 'wxm/course/index';
	  		let param = {
	  			page:1,
	  			per_page:10
	  		};
	  		this.$http.get(url, {params:param} ).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				var datas = res.data.data.data.slice(0,2);//只去前2条数据，由于排序要求不用分页per_page=3处理。
	  				var timestamp = Date.parse(new Date());
	        		timestamp = timestamp / 1000;
	        		for(var i = 0 ; i <datas.length ; i++){
			          datas[i].start_time = moment(datas[i].start_time * 1000).format("YYYY-MM-DD HH:mm");
			          if (datas[i].end_time > timestamp){
			            datas[i].issign = true;
			          }else{
			            datas[i].issign = false;
			          };
			          datas[i].end_timehm = moment(datas[i].end_time * 1000).format("HH:mm");
			        };
			        this.courseList = datas;
	  			}
	  		})
	  	},
	  	//下载
	  	down(url){
	  		if(!this.loginStatus){
	  			this.$message.error( '请先登录后，再次执行操作！' );
            	this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
            	return;
            }else if(!this.$store.state.mineInfo.have_company){
            	this.$message.error( '您还不是企业账号，只有企业账号才能下载课件！' );
            	return;
            }else{
            	window.open(
			      url,
			      '_blank'
			    );
            }
	  	},
	  	//预览
	  	preview(url){
	  		if(!this.loginStatus){
	  			this.$message.error( '请先登录后，再次执行操作！' );
            	this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
            	return;
            }else if(!this.$store.state.mineInfo.have_company){
            	this.$message.error( '您还不是企业账号，只有企业账号才能预览课件！' );
            	return;
            }else{
            	window.open(
            	  this.imgUrl + '/file/preview/' + url,
			      // url,
			      '_blank'
			    );
            }
	  	},
		//提交课程报名
		SignSubmitForm(formName){
			if( this.signning ){
                return;
            }
            if(!this.loginStatus){
            	this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
            	return;
            }
            this.$refs[formName].validate((valid) => {
                if( valid ){
                    this.signning = true;
                    let param = { 
                    	name: this.signform.name,
                    	company: this.signform.company,
                    	phone: this.signform.phone,
                    	job_title: this.signform.job_title,
                    	course_notice_id:this.cid
                    };
                    this.$http.post('wxm/course/apply', param).then(response => {
                        if( response.data.retcode == $conf.RETCODE_OK ){
                            
                        }else{
                            this.$message.error( response.data.errmsg );
                        }
                        this.signning = false;
                    }).catch(err => {
                        if( err.response ) {
                            switch( err.response.status ) {
                                case 422:
                                this.$message.error( '验证码错误！' );
                            }
                        }
                        this.signning = false;
                    });
                }else{
                    console.log('2222');
                }
            });
		},
	},
	watch:{
		$route(to,from){
		    this.cid = to.params.course_id;
		    this.getInfo();
			this.getCourse();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/legalCourse/courseInfo.vue